module.exports = __webpack_public_path__ + "img/w49.064672fe.svg";